export default "__VITE_ASSET__DzJo5kEd__"